/*eslint-disable*/
import { getTrainingsPage } from "../api/AuthenticationServices";

import { useState } from "react";
import { useEffect } from "react";
import { Card, CardMedia, CardContent, Typography } from "@mui/material";

const ImageCardContent = ({ image, title, subtitle }) => (
  <Card sx={{ display: "flex" }}>
    <CardMedia
      component="img"
      sx={{ width: "50%", objectFit: "cover" }}
      image={image}
      alt={title}
    />
    <CardContent sx={{ flex: 1 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ marginTop: 0 }}>
        {subtitle}
      </Typography>
    </CardContent>
  </Card>
);

function Trainings() {
  const [records, setRecords] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    try {
      const res = await getTrainingsPage();
      if (res.data.status === "success") {
        setRecords(res.data.data);
        console.log("Records ", records);
      }
    } catch (e) {
      console.log("Error " + e);
    }
  }

  return (
    <div className="card-wrapper">
      <h2
        style={{
          textAlign: "center",
          color: "white",
          fontFamily: "'Delicious Handrawn', cursive",
          fontSize: "40px",
        }}
      >
        TRAININGS
      </h2>
      {records.length > 0 ? (
        records.map((item) => {
          return (
            <div className="card-space">
              <ImageCardContent
                title={item.name}
                subtitle={item.purpose}
                image={item.imgLink}
              />
            </div>
          );
        })
      ) : (
        <h3>No training records found</h3>
      )}
    </div>
  );
}

export default Trainings;
